module.exports = __webpack_public_path__ + "static/apple-icon-64269032662d81a5f80648246605f698.png";